import React from 'react';
import Slider from 'react-slick';
import SliderElement from './slider-element';

export default class AutoplaySlider extends React.Component {
	render() {
		const settings = {
			centerMode: true,
			centerPadding: 0,
			dots: true,
			infinite: true,
			speed: 500,
			autoplaySpeed: 5000,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			cssEase: 'linear',
			pauseOnFocus: true
		};
		return (
			<div style={{ marginTop: '20px' }}>
				<Slider {...settings}>
					<div>
						<SliderElement name={'render2d'} text={'2D Rendering'} />
					</div>
					<div>
						<SliderElement name={'commercial'} text={'Commercial'}/>
					</div>
					<div>
						<SliderElement name={'newconstruction'} text={'New Construction'} />
					</div>
					<div>
						<SliderElement name={'residential1'} text={'Residential'} />
					</div>
				</Slider>
			</div>
		)
	}
}
